import React, {useRef} from 'react'
import AudioPlayer from '../components/AudioPlayer'
import AdjustingImage from '../components/AdjustingImage'


function AstInteractiveWhiteboard({containerSize}) {
	const headerRef = useRef()
	const footerRef = useRef()

	return(
		<div className="panel-body">
			<section className="asset-header" ref={headerRef}>
				<h1>Our interactive whiteboard</h1>
			</section>
			<section className="asset-content">
				{/* <img src="./assets/images/vi07864010_360tour_whiteboard.jpg" className="img-responsive" alt="Our interactive Whiteboard" /> */}
				<AdjustingImage src="./assets/images/vi07864010_360tour_whiteboard.jpg" alt="Our interactive Whiteboard"
					headerRef={headerRef}
					footerRef={footerRef}
					containerSize={containerSize}
					hasAudioPlayer={true}
				/>
				<AudioPlayer url="./assets/audio/au25864010_Track_002.mp3" />
			</section>
			<section className="asset-footer" ref={footerRef}>
				<p className="reference">Bildquelle: Fosseway Films Ltd. (Jesùs Santaeularia)<br/>
				Audioquellen: Tonmeister: Joschi Kauffmann, Stuttgart; Tonstudio: jkstudio GmbH, Stuttgart; Sprecher: Mark Borrill; Noch eine längere Angabe für die Audioquellen um viele Zeilen mit vielen Sprechern und anderen Beteiligten zu simmulieren.</p>
			</section>
		</div>
	)
}

export default AstInteractiveWhiteboard
